// src/middleware/auth.js

import {store} from "@/store/store.js";

export default {
  broker_zink: async (to, from, next) => {
    let status = await store.dispatch('fetch_user');
    const typesSet = new Set(['user_roles_types', 'country_states', 'communication_templates']);
    const toTypesSet = new Set(to.meta?.types ?? []);
    const allTypesSet = typesSet.union(toTypesSet);
    if (store.getters.user) {
      const params = {
        types: [
          ...allTypesSet,
        ],
      }
      await store.dispatch('fetch_types', { params });
      return next();
    } else {
      console.log("Your Session has expired.");
      next("/login");
    }
  },

  admin_zink: async (to, from, next) => {
    let status = await store.dispatch('fetch_user');
    let hasPermission = store.getters.user.permissions.includes('access administration-page');
    if (store.getters.user && hasPermission) {
      const typesSet = new Set(['user_roles_types', 'country_states', 'communication_templates']);
      const toTypesSet = new Set(to.meta?.types ?? []);
      const allTypesSet = typesSet.union(toTypesSet);
      const params = {
        types: [
          ...allTypesSet,
        ],
      }
      await store.dispatch('fetch_types', { params });
      return next();
    } else {
      console.log("You are not authorized.");
      next("/");
    }
  }
};
